import React, { useState } from 'react';
import { Invoice } from '../types';
import InvoiceLineBillingDateEditor from './InvoiceLineBillingDateEditor';
import Modal from './Modal';

interface InvoiceDetailsLinesTabProps {
  invoice: Invoice;
  onRefreshInvoice?: () => void;
}

const InvoiceDetailsLinesTab: React.FC<InvoiceDetailsLinesTabProps> = ({ invoice, onRefreshInvoice }) => {
  const [editingLineId, setEditingLineId] = useState<string | null>(null);
  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency
    }).format(amount);
  };

  const formatDateUTC = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString('de-DE', { timeZone: 'UTC' });

  return (
    <div className="card">
      <div className="card-header">
        <h3>Invoice Lines</h3>
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th className="read-only">Line Name</th>
              <th className="read-only">Description</th>
              <th className="read-only">Period</th>
              <th className="read-only">Quantity</th>
              <th className="read-only">Unit Price</th>
              <th className="read-only">Tax</th>
              <th className="read-only">Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {invoice.invoice_lines && invoice.invoice_lines.length > 0 ? (
              invoice.invoice_lines.map((line, idx) => (
                <tr key={idx} className="read-only">
                  <td>{line.invoiceline_name}</td>
                  <td>{line.description}</td>
                  <td>
                    {formatDateUTC(line.line_billing_start)} - {formatDateUTC(line.line_billing_end)}
                  </td>
                  <td>{line.quantity}</td>
                  <td>{formatCurrency(line.unit_price, invoice.currency)}</td>
                  <td>{line.tax_rate}%</td>
                  <td>{formatCurrency(line.line_total, invoice.currency)}</td>
                  <td>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEditingLineId(String(line.invoiceline_id))}
                      title="Edit billing period for this line"
                    >
                      Edit Period
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center' }}>
                  No invoice lines found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    {editingLineId && (
        <Modal
          title="Edit Line Billing Period"
          onClose={() => setEditingLineId(null)}
          fullPage
        >
          <InvoiceLineBillingDateEditor
            invoiceLineId={editingLineId}
            onSave={() => {
              // Trigger refresh of invoice details so UI shows updated period
              try { onRefreshInvoice && onRefreshInvoice(); } catch {}
              setEditingLineId(null);
            }}
            onCancel={() => setEditingLineId(null)}
          />
        </Modal>
      )}
    </div>
  );
};

export default InvoiceDetailsLinesTab;